<script>
import AwsServicesComponent from '@/components/Cloud/services/aws/services.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'AwsServicesView',
  components: { AwsServicesComponent },
  methods: {
    ...mapMutations('globalState/app', ['setTemplate']),
  },
};
</script>

<template>
  <AwsServicesComponent />
</template>
